import { useLocation } from 'react-router-dom'

const useIsViewingDashboard = () => {
  const location = useLocation()
  return location.pathname == '/'
}

export default useIsViewingDashboard
